import React from 'react';
import moment from 'moment';
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const ExpenseInvoiceTable = (props) => {

  const classes = useStyles();

  return (
    <TableContainer>
      <Divider/>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Employee ID</TableCell>
            <TableCell>Employee Name</TableCell>
            <TableCell>Salary Month</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={props.info.employeeDisplayId}>
            <TableCell component="th" scope="row">
              {props.info.employeeDisplayId}
            </TableCell>
            <TableCell component="th" scope="row">{props.info.employeeName}</TableCell>
            <TableCell component="th" scope="row">{moment(props.info.monthYear).format("MMMM / YYYY")}</TableCell>
            <TableCell component="th" scope="row">{props.info.total}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br></br>
    </TableContainer>
  )
};

export default ExpenseInvoiceTable;